import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../Redux/store";

// Add id {custID} for specific customer query
const baseUrl = 'https://customer.hirsch.com/account/v2/employee/customer';

interface FetchCustomerArgs {
    page?: number;
    writerId?: string | null;
};

interface CustomerResponse {
    customers: any[];
    page: number;
    totalPages: number;
}

export const getCustomers = createAsyncThunk<
    CustomerResponse, 
    FetchCustomerArgs | undefined, 
    { state: RootState }
    > ('customers/getCustomers',
    async(args,{ getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const params = new URLSearchParams();

            params.append('page', String(args?.page ?? 1));

            if (args?.writerId) params.append('writerId', args.writerId)

            if (!token) {
                throw new Error('No Auth Token Found')
            }

            const response = await fetch(`${baseUrl}?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                }
            })

            if(!response.ok) throw new Error('Failed to fetch')
            
            const json = await response.json()
            console.log('Customers:', json);
            return { 
                customers: json.customers, 
                page: args?.page ?? 1,
                totalPages: json.totalPages,
            }
        } catch (err: any) {
            return rejectWithValue(err.message)
        } 
    }
);

interface CustomerState {
    customersArr: any[];
    page: number;
    hasMore: boolean;
    loading: boolean;
    error: string | boolean | undefined | null;
};

const initialState: CustomerState = {
    customersArr: [],
    page: 1,
    hasMore: true,
    loading: false,
    error: null,
};

const customerSlice = createSlice({
    name: 'customers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getCustomers.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getCustomers.fulfilled, (state, action) => {
            state.loading = false;

            if (action.payload.page === 1) {
                state.customersArr = action.payload.customers;
            } else {
                state.customersArr.push(...action.payload.customers);
            }
            
            state.page = action.payload.page;
            state.hasMore = action.payload.page < action.payload.totalPages;
            state.error = false;
        })
        .addCase(getCustomers.rejected, (state, action) => {
            state.loading = false
            state.error = action.error ? action.error.message : 'Failed to Fetch';

        })
    }
})

export const customersReducer = customerSlice.reducer;

export const getCustomerList = (state: RootState) => {
    return state.customers.customersArr;
}
export const getCustomerPage = (state: RootState) =>
    state.customers.page;
export const getHasMoreCustomers = (state: RootState) =>
    state.customers.hasMore;
export const getCustomerLoading = (state: RootState) =>
    state.customers.loading;